var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59197 0C1.29598 0 0 1.25953 0 3.608L8.84472e-06 23.452C8.84472e-06 24.4828 0.444719 25.7714 2.59197 25.7714H18.1437C20.291 25.7714 20.7357 25.1271 20.7357 23.452V9.01999C20.7357 3.54023 17.9701 0 12.9598 0H2.59197ZM2.59197 1.28857H12.9598V7.73142H19.4397V23.452C19.4397 24.2348 18.8595 24.4828 18.1437 24.4828H2.59197C1.87622 24.4828 1.29599 24.2348 1.29599 23.452V3.608C1.29598 1.93286 1.87622 1.28857 2.59197 1.28857ZM14.2558 1.28857C16.344 1.75219 18.7917 3.22143 19.4397 6.44285H14.2558V1.28857Z",
    fill: "#AEB9D1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1431,
    y: 12.5714,
    width: 7.85714,
    height: 14.1429
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3097 14.1428L14.1431 17.155L15.1828 18.1743L16.5597 16.8646L16.5002 25.9285H18.0412V16.899L19.3733 18.2049L20.4288 17.2009L17.3097 14.1428Z",
    fill: "#AEB9D1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fileUpload.e25cfc9ced5928cfefa3fe8369bf129e.svg";